var lib_core = require("lib-core");

var PadData = require("./../footprint/padData.js");
var FootprintTerminalInstance = require("./footprintTerminalInstance.js");
var TechnologyData = require("./technologyData.js");

var PackageInstanceData = function (packageDescription) {
    var self = this;
    this.registerInstanceClass(["footprintInstances", "pads"], PadData, FootprintTerminalInstance);
    this.registerInstanceClass(["footprintInstances", "holes"]);   // TODO: see if we can omit this

    lib_core.InstanceBuilder.call(this, packageDescription);

    this.terminalMap = this.map("terminalMap", false);
    this.technologies = this.map("technologies", true);

    //tricky shit: observers changing the datamodel
    this.terminalMap.forEach(function(terminal) {
        terminal.onDie('terminal_map_die', function() {
            self.terminalMap.remove(terminal);
        });
    });
    this.terminalMap.onPut({}, function(m, terminal) {
        terminal.onDie('terminal_map_die', function() {
            self.terminalMap.remove(terminal);
        });
    });
    this.terminalMap.onRemove({}, function(m, terminal) {
        terminal.removeHandlers('terminal_map_die');
    });

};
lib_core.inherit(PackageInstanceData, lib_core.InstanceBuilder);
lib_core.JsonParser.registerClass(PackageInstanceData, "PackageInstanceData");

module.exports = PackageInstanceData;

PackageInstanceData.prototype.getTitle = function () {
    return this.description().metaData().name();
};

PackageInstanceData.prototype.getThumbnailURL = function () {
    return this.root?.asset?.thumbnail;
};

PackageInstanceData.prototype.addProperty = function(technology, name, value){
    var tech = this.technologies.get(technology);
    if(tech == undefined){ 
        var tech = new TechnologyData();
        this.technologies.put(technology, tech);
    }
    tech.properties.put(name, value);
} 
